module.exports = __webpack_public_path__ + "static/img/GO2.49327b24.jpg";